import styled from 'styled-components';
import { colors } from 'constants/colors';
import { BasicSectionContainer } from 'screens/style';
import passwordRetrieved from 'assets/icons/passwordRetrieved.jpg';
import { styleSizes } from "constants/styleSizes";

export const SetPasswordScreenContainer = styled(BasicSectionContainer)`
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  .buttonAndLink {
    display: flex;
    flex-direction: column;
    
    .buttonContainer {
      @media (max-width: ${styleSizes.mobileBreakpoint}) {
        width: auto!important;
      }
         button {
          @media (max-width: ${styleSizes.mobileBreakpoint}) {
            margin: 16px 0px 16px 20px;
          }
          
        }
      }
    .retrievedContainer {
      @media (max-width: ${styleSizes.mobileBreakpoint}) {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 0!important;
        white-space: nowrap;
      }


    }
    @media (max-width: ${styleSizes.mobileBreakpoint}) {
      flex-direction: row-reverse;
      align-items: center;
      width: 100%;
      }
  }
  .innerContainer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 414px;
    @media (max-width: ${styleSizes.tabletBreakpoint}) {
      height: 300px;
    }
    @media (max-width: ${styleSizes.tabletBreakpoint}) {
      align-items: baseline;
      padding-top: 56px;
    }
    @media (max-width: 770px) {
      height: 200px;
      padding: 20px 0 0 0;
    }
  }

  .titleContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${colors.forgotPasswordBackground};
    width: 100%;

    padding: 0 15px;
    position: relative;

    @media (max-width: ${styleSizes.tabletBreakpoint}) {
      height: 300px;
    }
    @media (max-width: 770px) {
      height: 200px;

    }

    .titleText {
      width: 100%;
      margin: 0 20px 0 0;
      position: relative;
      z-index: 20;
      .title {
        font-size: 48px;
        font-weight: bold;
        line-height: 72px;
        text-align: left;
        color: ${colors.white};

        @media (max-width: ${styleSizes.tabletBreakpoint}) {
          font-size: 32px;
          line-height: 48px;
        } 
        .highLight {
          color: ${colors.checkOutCompleteScreenHighlight};
        }
        @media (max-width: 770px) {


        } 
        @media (max-width: 590px) {
          font-size: 24px;
          line-height: 32px;
          width: 200px;
        } 
      }
    }

      .forgotPasswordImageImg {
        position: absolute;
        right: 31px;
        bottom: 0;
        width: 581px;
        height: auto;
        z-index: 10;
        @media (max-width: 1125px) {
          width: 461px;
        }
        @media (max-width: ${styleSizes.tabletBreakpoint}) {
          width: 369px;
        }
        @media (max-width: 770px) {
        width: 242px;
        right: 0;
        }
        @media (max-width: 420px) {
        width: 222px;
        right: -15px;
        }
      }

      .retrievedPasswordImageImg {
        position: absolute;
        right: 31px;
        bottom: 0;
        width: 582px;
        height: auto;    
        @media (max-width: 1232px) {
          width: 445px;
        }
        @media (max-width: ${styleSizes.tabletBreakpoint}) {
          width: 369px;
        }
        @media (max-width: 770px) {
        width: 242px;
        right: 0;
        }
        @media (max-width: 420px) {
        width: 222px;
        right: -15px;
        }
      }
    }

    .passwordRetrievedImage {
      width: 573px;
      min-width: 573px;
      height: 373px;
      background-image: url(${passwordRetrieved});
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      margin: 41px 0 0 0;
    }
  

  .inputRow {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 0 15px;

    .innerContainerForgotPassword {
      display: flex;
      flex-direction: column;
      max-width: 562px;

      min-width: 270px;
      padding: 64px 0 32px 0;
      align-items: center;
      @media (max-width: ${styleSizes.tabletBreakpoint}) {
          max-width: 750px;
        }
        @media (max-width: ${styleSizes.mobileBreakpoint}) {
          padding: 32px 0 32px 0;
        }
      .description {
        font-size: 16px;
        font-weight: 600;
        color: ${colors.black};
        margin: 0 0 32px 0;
        @media (max-width: ${styleSizes.mobileBreakpoint}) {
          font-weight: 400;
          text-align: left;
        }


        .highLight {
          font-weight: 600;
        }
      }

      .contactText {
        margin: 32px 0;
        font-size: 16px;
        color: ${colors.black};
        line-height: 24px;

        .link {
          color: ${colors.hoverBlue};
        }
      }

      .sentText {
        line-height: 24px;
        @media (max-width: ${styleSizes.mobileBreakpoint}) {
          text-align: left;
        }
      }

      .stillText {
        margin: 32px 0 8px 0;
        @media (max-width: ${styleSizes.mobileBreakpoint}) {
          width: 100%;
          text-align: left;
        }
      }

      .buttonContainer {
        width: 238px;
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .contactContainer {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 32px;
      }

      .retrievedContainer {
        max-width: 550px;
        padding: 0 20px;
        @media (max-width: ${styleSizes.tabletBreakpoint}) {
          max-width: 750px;
        }
        @media (max-width: ${styleSizes.mobileBreakpoint}) {
          padding: 0;
        }
        .highLight {
          font-weight: 600;
          color: ${colors.hoverBlue};
        }

        .link {
          color: ${colors.hoverBlue};
          cursor: pointer;
          text-decoration: underline;
        }
      }
    }
  }

  /* @media only screen and (max-width: 1200px) {

    .innerContainer {
      flex-direction: column-reverse;
      padding: 0;
      margin: 0;
    }

    .titleContainer {
      height: auto;

      .titleText {
        margin: 20px 0;

        .title {
          text-align: center;
          font-size: 36px;
        }

        .description {
          text-align: center;
        }
      }

      .forgotPasswordImage, .passwordRetrievedImage {
        max-width: 270px;
        min-width: 270px;
        height: 183px;
        margin-top: 20px;
      }
    }
  } */
`;